import "core-js/modules/es.object.assign.js";
import { h } from "vue";
//@ts-ignore
import { getDefaultSvgPropsValues } from "@vueEntry/SvgIcons/DefaultValues";
export var VideoIcon = (props, _ref) => {
  var {
    attrs
  } = _ref;
  var _a, _b, _c, _d, _e, _f;
  props = Object.assign(Object.assign({}, getDefaultSvgPropsValues()), props);
  var {
    width,
    height,
    strokeColor,
    fillColor
  } = props;
  return h("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.666 17.3",
    width: "".concat(width),
    height: "".concat(height),
    class: (_a = props.class) !== null && _a !== void 0 ? _a : "",
    "aria-hidden": (_b = attrs["aria-hidden"]) !== null && _b !== void 0 ? _b : "true"
  }, [h("g", {
    fill: fillColor,
    stroke: (_c = attrs["stroke-color"]) !== null && _c !== void 0 ? _c : strokeColor,
    "stroke-linecap": "".concat((_d = attrs["stroke-linecap"]) !== null && _d !== void 0 ? _d : "round"),
    "stroke-linejoin": "".concat((_e = attrs["stroke-linejoin"]) !== null && _e !== void 0 ? _e : "round"),
    "stroke-width": "".concat((_f = attrs["stroke-width"]) !== null && _f !== void 0 ? _f : "1"),
    "d": "M16.65 13.983a2.667 2.667 0 0 1-2.666 2.667H3.317A2.667 2.667 0 0 1 .65 13.983V3.316A2.666 2.666 0 0 \n            1 3.317.65h10.667a2.666 2.666 0 0 1 2.666 2.666v6.217m-9.244-.054H.657m6.852-4.461V1.379m0 11.675V8.787"
  }, [h("path", {
    d: "M13.844 16.65H3.46a3.046 3.046 0 0 1-2.81-3.237V3.901A3.047 3.047 0 0 1 3.456.664L13.841.65a3.044 \n                3.044 0 0 1 2.809 3.235v9.528a3.047 3.047 0 0 1-2.806 3.237Z"
  }), h("path", {
    d: "m21.51 15.709-4.86-1.828v-10l4.77-2.1a1.843 1.843 0 0 1 2.463 1.183 2.3 2.3 0 0 1 \n                .133.773v9.973a2.008 2.008 0 0 1-1.9 2.1 1.722 1.722 0 0 1-.606-.101Z"
  })])]);
};